var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaloAlto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.556 5.04687L11.2731 2.74414L8.99023 5.04687L10.1217 6.19823L4.40463 11.9551L6.68751 14.2578L8.97038 11.9551L7.83887 10.8037L13.556 5.04687ZM0.990234 8.50096L3.27311 10.8037L8.99023 5.04687L6.70736 2.74414L0.990234 8.50096ZM8.97038 11.9352L11.2533 14.2379L16.9704 8.48111L14.7074 6.17838L8.97038 11.9352Z",
    fill: "#FA582D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaloAlto);
export default __webpack_public_path__ + "static/media/PaloAlto.295f084c3b05f775b76cbaaf9f97e6d9.svg";
export { ForwardRef as ReactComponent };